import React from "react";
import { useRoutes } from "react-router-dom";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import "./App.css";
import { routes } from "./router";
import { PageLayout } from "./components/PageLayout"; // new import

initializeIcons();

const App: React.FC = () => {
    const element = useRoutes(routes);
    return (
        <div className="App">
            <PageLayout>
                {element}
                {/* <Routes>
                    <Route path="/" element={<TaskOverview />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/report/*" element={<Comparison />} />
                </Routes> */}
            </PageLayout>
        </div>
    );
};
export default App;
